import styled from 'styled-components';

export const StyledBannerWrapper = styled.div`
  margin: -0.8rem -1rem 0rem;
  padding-bottom: 0.8rem;
`;

export const StyledWrapper = styled.div`
  margin-top: 0.5rem;
`;

export const StyledLinkWrapper = styled.div`
  @media (max-height: 568px), (max-width: 320px) {
    margin-top: 0.5rem;
    margin-bottom: 1rem;
  }

  margin-top: 0.5rem;
`;

export const StyledButtonWrapper = styled.div`
  @media (max-height: 568px), (max-width: 320px) {
    display: flex;
    flex-direction: column;
  }
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 0.5rem;
`;
